import { Result, Row } from "antd";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import Button from "../../components/Button";
import VeloPrimeIcon from "../../assets/veloprime/icons/icon-veloprime-white.png";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-color: var(--veloprime-background-color);
  .ant-result-subtitle,
  .ant-result-title {
    color: var(--white);
  }
  svg.error * {
    fill: var(--ant-error-color);
  }
`;

const PageNotFound: React.FC = () => {
  const navigate = useNavigate();
  return (
    <Container>
      <Result
        icon={<img src={VeloPrimeIcon} alt="VeloPrime" style={{ width: "150px", height: "auto" }} />}
        title="Página não encontrada"
        subTitle="Esta página que você visitou não existe"
        extra={
          <Row justify="center">
            <Button size="large" buttonType="veloprime" onClick={() => navigate("/")}>
              Voltar para o app
            </Button>
          </Row>
        }
      />
    </Container>
  );
};

export default PageNotFound;
